export default "__VITE_ASSET__lwcd1cKS__"